import React from "react";
import Permissioncard from "./default/components/Permissioncard";

const Permission = () => {
  return <Permissioncard />;
};

export default Permission;
